import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { tasksId } from "../types/activityTasks";

const routesRedirect = {
	tema1: "/home1/",
	tema2: "/home1/",
	tema3: "/home1/",
	tema4: "/home1/"
}


export const LayoutHome = () => {
	const { activitiesInformation } = useSelector((state) => state.menu);
	const navigate = useNavigate()
	const location = useLocation();

	const countActivitiesByTopic = (tasks) => {
		const result = {};

		let totalCount = 0;
		for (const tema in tasks) {
			const activitiesCount = Object.keys(tasks[tema].activities).length;
			totalCount += activitiesCount;

			result[tema] = {
				count: activitiesCount,
				min: totalCount - activitiesCount + 1,
				max: totalCount,
			};
		}

		return result;
	};

	const redirectRouterByActivy = () => {
		if (location.pathname !== "/") {
			return
		}
		let pathRedirect = routesRedirect.tema1
		let countTaskComplete = 0
		let breakTask = false
		const valuesTopics = Object.values(activitiesInformation);
		valuesTopics.forEach((act) => {
			if (!act.isOpen) {
				breakTask = true
				return;
			}
			if (!breakTask) {
				countTaskComplete++
			}
		})

		const countTask = countActivitiesByTopic(tasksId)
		for (const key in countTask) {
			if (Object.hasOwnProperty.call(countTask, key)) {
				const element = countTask[key];
				if (countTaskComplete >= element.min) {
					pathRedirect = routesRedirect[key]
				}
			}
		}
		navigate(pathRedirect)
	}


	useEffect(() => {
		redirectRouterByActivy()
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])
	return (
		<>
			<Outlet />
		</>
	);
};
